var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGameActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Game_active",
    "data-name": "Game active",
    d: "M28.9,13.632A8.708,8.708,0,0,0,20.374,6H11.626A8.708,8.708,0,0,0,3.1,13.632c-.069.5-1.1,7.744-1.1,8.248A4.058,4.058,0,0,0,5.993,26a3.983,3.983,0,0,0,3.572-2.278L12,19h8l2.435,4.722A3.982,3.982,0,0,0,26.007,26,4.058,4.058,0,0,0,30,21.88c0-.5-1.028-7.749-1.1-8.248ZM22,9a1.333,1.333,0,1,1-1.333,1.333A1.333,1.333,0,0,1,22,9Zm-9,5H11v2H9V14H7V12H9V10h2v2h2Zm6.333.333A1.333,1.333,0,1,1,20.666,13,1.333,1.333,0,0,1,19.333,14.333ZM22,17a1.333,1.333,0,1,1,1.333-1.333A1.333,1.333,0,0,1,22,17Zm2.667-2.667A1.333,1.333,0,1,1,26,13,1.333,1.333,0,0,1,24.667,14.333Z",
    transform: "translate(-2 -6)",
    fill: "#ffcfe9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGameActive);
export default __webpack_public_path__ + "static/media/icon_game_active.41d0f86a00df8a057c3349818fe20e59.svg";
export { ForwardRef as ReactComponent };